export default {"src":"/_next/static/media/shareholder_guide_1.688df6b5.svg","height":278,"width":778,"blurWidth":0,"blurHeight":0};